(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["discount-code-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  let discountDrawerRoot = document.querySelector(".discount-drawer-root");
  if (!discountDrawerRoot) {
    discountDrawerRoot = document.createElement("div");
    discountDrawerRoot.className = "discount-drawer-root";
    discountDrawerRoot.innerHTML = `
      <div class="discount-drawer-panel" role="region" aria-modal="true" aria-hidden="true" tabindex="-1">
        <div class="discount-drawer-header">
          <h4 class="discount-drawer-title"></h4>
          <button class="discount-drawer-close" aria-label="Close drawer">&times;</button>
        </div>
        <div class="discount-drawer-content">
          <div class="discount-drawer-body"></div>
        </div>
      </div>
    `;
    document.body.appendChild(discountDrawerRoot);
  }

  const discountDrawerPanel = discountDrawerRoot.querySelector(".discount-drawer-panel");
  const discountDrawerTitle = discountDrawerRoot.querySelector(".discount-drawer-title");
  const discountDrawerContent = discountDrawerRoot.querySelector(".discount-drawer-body");
  const discountCloseBtn = discountDrawerRoot.querySelector(".discount-drawer-close");

  document.querySelectorAll(".discount-code-trigger").forEach(trigger => {
    const blockId = trigger.closest("div").nextElementSibling?.id?.replace("discount-content-", "");
    if (!blockId) return;

    trigger.addEventListener("click", () => {
      const content = document.getElementById(`discount-content-${blockId}`);
      if (content) {
        discountDrawerContent.innerHTML = content.innerHTML;
        const h4 = content.querySelector("h4");
        discountDrawerTitle.textContent = h4 ? h4.textContent : "";
      }

      discountDrawerRoot.classList.add("is-open");
      discountDrawerPanel.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      discountDrawerPanel.focus();
    });
  });

  const closeDiscountDrawer = () => {
    discountDrawerRoot.classList.remove("is-open");
    discountDrawerPanel.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  discountCloseBtn.addEventListener("click", closeDiscountDrawer);
  discountDrawerRoot.addEventListener("click", e => {
    if (e.target === discountDrawerRoot) closeDiscountDrawer();
  });
  document.addEventListener("keydown", e => {
    if (e.key === "Escape" && discountDrawerRoot.classList.contains("is-open")) {
      closeDiscountDrawer();
    }
  });


});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["drawer-accordion-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  let drawerRoot = document.querySelector(".custom-drawer-root");
  if (!drawerRoot) {
    drawerRoot = document.createElement("div");
    drawerRoot.className = "custom-drawer-root";
    drawerRoot.innerHTML = `
      <div class="custom-drawer-panel" role="region" aria-modal="true" aria-hidden="true" tabindex="-1">
        <div class="custom-drawer-header">
          <h4 class="custom-drawer-title"></h4>
          <button class="custom-drawer-close" aria-label="Close drawer">&times;</button>
        </div>
        <div class="custom-drawer-content">
          <div class="custom-drawer-body"></div>
        </div>
      </div>
    `;
    document.body.appendChild(drawerRoot);
  }

  const drawerPanel = drawerRoot.querySelector(".custom-drawer-panel");
  const drawerTitle = drawerRoot.querySelector(".custom-drawer-title");
  const drawerContent = drawerRoot.querySelector(".custom-drawer-body");
  const closeBtn = drawerRoot.querySelector(".custom-drawer-close");

  document.querySelectorAll(".custom-drawer-trigger").forEach(trigger => {
    const blockId = trigger.closest("div").nextElementSibling?.id?.replace("drawer-content-", "");
    if (!blockId) return;

    trigger.addEventListener("click", () => {
      const content = document.getElementById(`drawer-content-${blockId}`);
      if (content) {
        drawerContent.innerHTML = content.innerHTML;
        const h4 = content.querySelector("h4");
        drawerTitle.textContent = h4 ? h4.textContent : "";
      }

      drawerRoot.classList.add("is-open");
      drawerPanel.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      drawerPanel.focus();
    });
  });

  const closeDrawer = () => {
    drawerRoot.classList.remove("is-open");
    drawerPanel.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  closeBtn.addEventListener("click", closeDrawer);
  drawerRoot.addEventListener("click", e => {
    if (e.target === drawerRoot) closeDrawer();
  });
  document.addEventListener("keydown", e => {
    if (e.key === "Escape" && drawerRoot.classList.contains("is-open")) {
      closeDrawer();
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-specification-popup-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const triggerElements = document.querySelectorAll('[data-spec-popup-id]');
    triggerElements.forEach(function(triggerElement) {
      const blockId = triggerElement.getAttribute('data-spec-popup-id');
      if (!blockId) return;
      
      let drawerRoot = document.querySelector('.spec-popup-root-' + blockId);
    if (!drawerRoot) {
      drawerRoot = document.createElement('div');
      drawerRoot.className = 'spec-popup-root-' + blockId;
      drawerRoot.innerHTML = 
      '<div class="spec-popup-panel-' + blockId + '" role="region" aria-modal="true" aria-hidden="true" tabindex="-1">' +
        '<div class="spec-popup-header-' + blockId + '">' +
          '<h4 class="spec-popup-title-' + blockId + '"></h4>' +
          '<button class="spec-popup-close-' + blockId + '" aria-label="Close drawer">&times;</button>' +
        '</div>' +
        '<div class="spec-popup-content-' + blockId + '">' +
          '<div class="spec-popup-body"></div>' +
        '</div>' +
      '</div>';
      document.body.appendChild(drawerRoot);
      }

      const drawerPanel = drawerRoot.querySelector('.spec-popup-panel-' + blockId);
      const drawerTitle = drawerRoot.querySelector('.spec-popup-title-' + blockId);
      const drawerContent = drawerRoot.querySelector('.spec-popup-body');
      const closeBtn = drawerRoot.querySelector('.spec-popup-close-' + blockId);

      const trigger = triggerElement.querySelector('.spec-popup-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function() {
        const triggerBlockId = triggerElement.nextElementSibling?.id?.replace('drawer-content-', '');
        if (!triggerBlockId) return;
        
        const content = document.getElementById('drawer-content-' + triggerBlockId);
        if (content) {
          drawerContent.innerHTML = content.innerHTML;
          const h4 = content.querySelector('h4');
          drawerTitle.textContent = h4 ? h4.textContent : '';
        }

        drawerRoot.classList.add('is-open');
        drawerPanel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        drawerPanel.focus();
      });

      const closeDrawer = function() {
        drawerRoot.classList.remove('is-open');
        drawerPanel.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      closeBtn.addEventListener('click', closeDrawer);
      drawerRoot.addEventListener('click', function(e) {
        if (e.target === drawerRoot) closeDrawer();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawerRoot.classList.contains('is-open')) {
          closeDrawer();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-popup-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    let drawerRoot = document.querySelector('.custom-drawer-root');
    if (!drawerRoot) {
      drawerRoot = document.createElement('div');
      drawerRoot.className = 'custom-drawer-root';
      drawerRoot.innerHTML = `
      <div class="custom-drawer-panel" role="region" aria-modal="true" aria-hidden="true" tabindex="-1">
        <div class="custom-drawer-header">
          <h4 class="custom-drawer-title"></h4>
          <button class="custom-drawer-close" aria-label="Close drawer">&times;</button>
        </div>
        <div class="custom-drawer-content">
          <div class="custom-drawer-body"></div>
        </div>
      </div>
    `;
      document.body.appendChild(drawerRoot);
    }

    const drawerPanel = drawerRoot.querySelector('.custom-drawer-panel');
    const drawerTitle = drawerRoot.querySelector('.custom-drawer-title');
    const drawerContent = drawerRoot.querySelector('.custom-drawer-body');
    const closeBtn = drawerRoot.querySelector('.custom-drawer-close');

    document.querySelectorAll('.custom-drawer-trigger').forEach((trigger) => {
      const blockId = trigger.closest('div').nextElementSibling?.id?.replace('drawer-content-', '');
      if (!blockId) return;

      trigger.addEventListener('click', () => {
        const content = document.getElementById(`drawer-content-${blockId}`);
        if (content) {
          drawerContent.innerHTML = content.innerHTML;
          const h4 = content.querySelector('h4');
          drawerTitle.textContent = h4 ? h4.textContent : '';
        }

        drawerRoot.classList.add('is-open');
        drawerPanel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        drawerPanel.focus();
      });
    });

    const closeDrawer = () => {
      drawerRoot.classList.remove('is-open');
      drawerPanel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    closeBtn.addEventListener('click', closeDrawer);
    drawerRoot.addEventListener('click', (e) => {
      if (e.target === drawerRoot) closeDrawer();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawerRoot.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
